import {
  ConditionLogicId,
  IBrand,
  ICampaignEntryContext,
  IConditionLogicImplementation,
  IDynamicForm,
  ITemplateScopeData,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

export class NeverCondition
  implements IConditionLogicImplementation<ITemplateScopeData, undefined>
{
  conditionId = ConditionLogicId.Never;
  description = 'This condition will never be met';

  isValidContext(_data: unknown): _data is ITemplateScopeData {
    return true;
  }

  isTrue(_config: undefined, _context: ITemplateScopeData): boolean {
    return false;
  }

  checkCampaignEntry(
    _config: undefined,
    _entryContext: ICampaignEntryContext
  ): boolean {
    return false;
  }

  async getForm(_brand: WithRef<IBrand>): Promise<IDynamicForm> {
    return Promise.resolve({});
  }

  async getSummary(_config: undefined): Promise<string | undefined> {
    return Promise.resolve('This condition is never met');
  }
}

export class AlwaysCondition
  implements IConditionLogicImplementation<ITemplateScopeData, undefined>
{
  conditionId = ConditionLogicId.Always;
  description = 'This condition will always be met';

  isValidContext(_data: unknown): _data is ITemplateScopeData {
    return true;
  }

  isTrue(_config: undefined, _context: ITemplateScopeData): boolean {
    return true;
  }

  checkCampaignEntry(
    _config: undefined,
    _entryContext: ICampaignEntryContext
  ): boolean {
    return true;
  }

  async getForm(_brand: WithRef<IBrand>): Promise<IDynamicForm> {
    return Promise.resolve({});
  }

  async getSummary(_config: undefined): Promise<string | undefined> {
    return Promise.resolve(undefined); // No summary needed for Always condition
  }
}
